import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { isDevMode } from '@angular/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
    private missingTranslations: string[] = [];

    handle(params: MissingTranslationHandlerParams) {
        const currentLang = params.translateService.currentLang;
        if (currentLang != 'en') {
            if (Object.values(params.translateService.translations[currentLang]).indexOf(params.key) == -1) {
                // check the shared service for missing translations list
                if (this.missingTranslations.indexOf(params.key) == -1) {
                    this.missingTranslations.push(params.key);
                    if (isDevMode()) {
                        console.log('Missing Translations : ', this.missingTranslations);
                    }
                }
            }
        }
        // look in the translation
        return params.key;
    }

    constructor() {
    }

}
